import { Box, CircularProgress, styled } from '@mui/material';

interface SpinnerProps {
  posY?: number | string;
  backdrop?: boolean;
}

const AbsolutePositionedBox = styled(Box)(({ opacity }: { opacity: number }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundColor: `rgba(255, 255, 255, ${opacity})`,
  display: 'flex',
  justifyContent: 'center',
  zIndex: 10,
}));

const Spinner = ({ posY, backdrop }: SpinnerProps) => {
  return (
    <AbsolutePositionedBox opacity={backdrop ? 0.7 : 0}>
      <CircularProgress sx={{ mt: posY }} />
    </AbsolutePositionedBox>
  );
};

export default Spinner;
